import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../baseQuery";

export const packageApi = createApi({
    reducerPath: "packageApi",
    baseQuery,
    tagTypes: ["package"],
    keepUnusedDataFor: 0,
    endpoints: (builder) => ({
        getPackages: builder.query({
            query: () => "site-packages",
            providesTags: ["package"],
        }),
    }),
});

export const { useGetPackagesQuery } =
    packageApi;
